import { useEffect, useState } from 'react'

import { toast } from 'react-toastify'

import { GeodecoderHelper } from '../helpers/helper-geodecoder'
import isHttpError from '../helpers/helper-http-error'

import IAdress from '../interfaces/adress'
import IGeocode from '../interfaces/geocode'

export const useMap = (address?: IAdress) => {
  const [location, setLocation] = useState<IGeocode>()

  useEffect(() => {
    const geocode = async () => {
      if (!address) {
        return
      }

      try {
        const result = await GeodecoderHelper.geocodeAddress(address)

        if (result) {
          setLocation(result)
        }
      } catch (error) {
        const httpError = isHttpError(error)

        if (httpError) {
          toast.error(httpError.message)
        } else {
          throw error
        }
      }
    }

    geocode()
  }, [address])

  return { location }
}
